import React from 'react';
import { useInput } from 'react-admin';
import DepartmentFilterField from '../../prestataires/DepartmentFilterField';

/** react-admin filter around the department map: sends `department[]` to the ANC list API (coreapi or statisticsservice). */
const DepartmentFilterInput = ({ source }: { source: string; alwaysOn?: boolean }) => {
    const { input } = useInput({ source });
    const value: number[] = Array.isArray(input.value) ? input.value.map(Number) : [];

    return <DepartmentFilterField value={value} onChange={(codes) => input.onChange(codes.length ? codes : undefined)} />;
};

export default DepartmentFilterInput;
